import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { flushAnalytics, trackActivity } from '@/lib/analytics';
import { engagementSeconds, shouldCountEngagement } from '@/lib/analyticsModel';

export function AnalyticsTracker() {
  const { pathname } = useLocation(); const { user } = useAuth();
  const lastPage = useRef('');
  useEffect(() => {
    const key = `${user?.userId || 'anonymous'}:${pathname}`;
    if (key === lastPage.current) return;
    const identityChanged = lastPage.current.split(':')[0] !== key.split(':')[0];
    lastPage.current = key;
    if (identityChanged) trackActivity('pwa_launch');
    trackActivity('page_view');
    void flushAnalytics();
  }, [pathname, user?.userId]);
  useEffect(() => {
    let lastInteraction = Date.now(), previous = performance.now(), foreground = document.visibilityState === 'visible';
    const interact = () => { lastInteraction = Date.now(); };
    const tick = (visible = document.visibilityState === 'visible') => {
      const now = performance.now();
      if (foreground && shouldCountEngagement(visible, Date.now(), lastInteraction)) {
        const seconds = engagementSeconds(now - previous); if (seconds) trackActivity('engagement', { seconds });
      }
      previous = now;
    };
    const visibility = () => { tick(foreground); foreground = document.visibilityState === 'visible'; previous = performance.now(); if (!foreground) void flushAnalytics(true); };
    const leave = () => { tick(foreground); void flushAnalytics(true); };
    const online = () => { void flushAnalytics(); };
    for (const name of ['pointerdown', 'keydown', 'scroll', 'touchstart']) window.addEventListener(name, interact, { passive: true });
    document.addEventListener('visibilitychange', visibility); window.addEventListener('pagehide', leave); window.addEventListener('online', online);
    const engageTimer = window.setInterval(() => tick(), 15000); const uploadTimer = window.setInterval(() => { void flushAnalytics(); }, 5000);
    return () => { clearInterval(engageTimer); clearInterval(uploadTimer); for (const name of ['pointerdown', 'keydown', 'scroll', 'touchstart']) window.removeEventListener(name, interact); document.removeEventListener('visibilitychange', visibility); window.removeEventListener('pagehide', leave); window.removeEventListener('online', online); };
  }, []);
  return null;
}
